import { useEffect, useCallback, useContext, useState } from "react";
import { Context as ThemeContext } from "../context/ThemeContext";
import { darkTheme, lightTheme } from "../App.theme";

export default () => {
  const {
    state: { darkMode },
    checkLocalTheme
  } = useContext(ThemeContext);

  const [theme, setTheme] = useState(lightTheme);

  const stableChecking = useCallback(checkLocalTheme, []);

  useEffect(() => {
    stableChecking();
  }, [stableChecking]);

  useEffect(() => {
    if (darkMode) {
      setTheme(darkTheme);
    } else {
      setTheme(lightTheme);
    }
  }, [darkMode]);

  return [{ theme, darkMode }];
};
